import * as angular from 'angular';
import {ConfigService} from "../modules/ConfigModule";
import {StateService} from "@uirouter/angularjs";

class MenuItem {
    constructor(public id: string, public name: string, public faIcon: string, public url: string, visible: Boolean = true, custom: string = null) {
    }
}

class MenuGroup {
    constructor(public name: string, public  items: MenuItem[], public  panelContext: string = "primary", public  visible: Boolean = true) {
    }
}

export class MenuService {
    groups: MenuGroup[];

    constructor(private $config: ConfigService, $rootScope: ng.IRootScopeService, private $state: StateService) {
        $rootScope.$watch(() => $config.userInfo, () => this.refreshMenu($config.userInfo))
    }

    refreshMenu = (userInfo) => {
        if (!userInfo) {
            this.groups = [];
            return;
        }

        let href = this.$state.href;
        var isStaff = userInfo.roles.some(x => x.name === "Staff");
        var isDeveloper = userInfo.roles.some(x => x.name === "Developer");

        this.groups = [
            new MenuGroup('Lead', [
                new MenuItem('leadDashboard', 'Lead Dashboard', 'fad fa-columns', href('lead.dashboard')),
                new MenuItem('leadAdd', 'Add Lead', 'fad fa-phone-plus', href('customer.new', {lead: 1})),
            ], 'primary', isStaff),

            new MenuGroup('Customer', [
                new MenuItem('customerAdd', 'Add Customer', 'fad fa-user-plus', href('customer.new')),
                new MenuItem('receivePayment', 'Receive Payment', 'fad fa-money-bill-wave', href('payment.receive')),
                new MenuItem('licenseList', 'Licensing', 'fad fa-key', href('license.list')),
                new MenuItem('subList', 'Subs', 'fad fa-usd-circle', href('txnTemplate.list')),
                new MenuItem('tags', 'Tags', 'fad fa-tags', href('customer.tags')),
            ], 'primary', isStaff),

            new MenuGroup('Activity', [
                new MenuItem('activityDashboard', 'Activity Dashboard', 'fad fa-columns', href('activity.dashboard')),
            ], 'primary', isStaff),

            new MenuGroup('Case', [
                new MenuItem('caseWizard', 'Case Wizard', 'fad fa-hat-wizard', href('case.create')),
                new MenuItem('caseList', 'Case List', 'fad fa-briefcase', href('case.list')),
                new MenuItem('companyList', 'Company List', 'fad fa-building', href('company.list')),
                new MenuItem('caseTypeList', 'Case Types', 'fad fa-font-case', href('case.type')),
            ], 'primary', isStaff),

            new MenuGroup('Payments', [
                new MenuItem('invoiceAutoDebit', 'Auto-Debit', 'fas fa-file-invoice-dollar', href('invoice.auto')),
                new MenuItem('batch', 'Batches', 'fas fa-money-check-alt', href('payment.batch')),
                new MenuItem('unlinkedProfile', 'Unlinked Profiles', 'fad fa-unlink', href('payment.unlinkedProfile')),
                new MenuItem('unlinkedTransaction', 'Unlinked Txns', 'fad fa-unlink', href('payment.unlinkedTransaction')),
                new MenuItem('transactionsWithoutPaymentProfile', 'Txns w/o Profile', 'fad fa-unlink', href('payment.transactionsWithoutPaymentProfile')),
                new MenuItem('cardMigration', 'CC Migration', 'fad fa-long-arrow-right', href('payment.migration')),
            ], 'primary', isStaff),

            new MenuGroup('Imports', [
                new MenuItem('intuitPartnerPayment', 'Intuit Partner Payments', 'fas fas fa-file-import', href('import.intuitPartnerPayment')),
                new MenuItem('merchantResidual', 'Merchant Residuals', 'fas fas fa-file-import', href('import.merchantResidual')),
            ], 'primary', isStaff),

            new MenuGroup('Developer', [
                new MenuItem('logs', 'Logs', 'fas fa-file-exclamation', href('developer.log')),
                new MenuItem('debug', 'Debug', 'fas fa-bug', href('developer.debug')),
                new MenuItem('userActivity', 'User Activity', 'fas fa-users', href('developer.userActivity')),
                new MenuItem('qbSyncStatus', 'QB Sync Status', 'fas fa-poo-storm', href('developer.qbSyncStatus'), true,
                    "<span class='badge'>{{vm.qbPending}}</span>"),
                new MenuItem('hangfire', 'Hangfire', 'fas fa-fire', this.$config.apiBase + '../hangfire'),
            ], 'danger', isDeveloper)
        ];
    }
}

export default angular.module('services.menu', [])
    .service('$menu', MenuService)
    .name;
